import { BlockTitle } from "@blocks/Blocks";

import ConfidentialitySection from "./ConfidentialitySection";
import FinancialDocumentsSection from "./FinancialDocumentsSection";
import FinancialProjectionsSection from "./FinancialProjectionsSection";
import ManagementAccountsSection from "./ManagementAccountsSection";
import SupportingDocumentsSection from "./SupportingDocumentsSection";

/**
 * Component to render Documentation section for FAQ Page
 */
const DocumentationSection = (): React.ReactElement => {
  return (
    <>
      <BlockTitle
        text="Documentation"
        rootClassName="bg-gray-150 lg:text-xl font-medium py-6 pl-4 font-poppins"
      />

      <ConfidentialitySection />

      <FinancialDocumentsSection />

      <FinancialProjectionsSection />

      <SupportingDocumentsSection />

      <ManagementAccountsSection />
    </>
  );
};

export default DocumentationSection;
